export default {
    list: 'notifications/list',
    remove: 'notifications/remove',
    clear: 'notifications/clear',
    checkLatest: 'notifications/checkLatest'
};